import { render, staticRenderFns } from "./toolbar-button-service-rating.vue?vue&type=template&id=6f70b4e8"
import script from "./toolbar-button-service-rating.vue?vue&type=script&lang=ts"
export * from "./toolbar-button-service-rating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports